<template>
    <div class="button-bar">
        <button
            v-if="back_button_show"
            class="button"
            @click.prevent="back_button_action()"
            :disabled="!back_button_enable">
            {{back_button_label}}
        </button>
        <button
            v-if="abandon_button_show"
            class="button"
            @click="abandon_button_action()"
            :disabled="!abandon_button_enable">
            Abandon claim
        </button>
        <button
            v-if="save_button_show"
            class="button"
            @click="save_button_action()"
            :disabled="!save_button_enable">
            Save for later
        </button>
        <button
            v-if="next_button_show"
            class="button"
            @click.prevent="next_button_action()"
            :disabled="!next_button_enable">
            {{next_button_label}}
        </button>
    </div>
</template>

<script>
export default {
  name: 'formButtonBar',
  props: {
    back_button_enable: {
      required: false,
      type: Boolean,
      default: true
    },
    back_button_show: {
      required: false,
      type: Boolean,
      default: true
    },
    back_button_action: {
      required: false,
      type: Function,
      default: () => {}
    },
    back_button_label: {
      required: false,
      type: String,
      default: 'Back'
    },
    abandon_button_enable: {
      required: false,
      type: Boolean,
      default: true
    },
    abandon_button_show: {
      required: false,
      type: Boolean,
      default: false
    },
    abandon_button_action: {
      required: false,
      type: Function,
      default: () => {}
    },
    save_button_enable: {
      required: false,
      type: Boolean,
      default: true
    },
    save_button_show: {
      required: false,
      type: Boolean,
      default: false
    },
    save_button_action: {
      required: false,
      type: Function,
      default: () => {}
    },
    next_button_enable: {
      required: true,
      type: Boolean
    },
    next_button_show: {
      required: true,
      type: Boolean
    },
    next_button_action: {
      required: true,
      type: Function
    },
    next_button_label: {
      required: false,
      type: String,
      default: 'Next'
    }

  },
  methods: {

  }
}
</script>

